// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"fe19c91d","239":"dac06248","336":"c63abea6","453":"f88409ed","455":"7ac8d574","691":"4765baa2","743":"a4604dcd","794":"b61ee55e","797":"a5112f2f","824":"6c91f263","977":"e9d662d1"}[chunkId] + ".chunk.js";
};